/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1SerievideoVideoidLangsId202,
  PutApiV1SerievideoVideoidLangsId400,
  PutApiV1SerievideoVideoidLangsId401,
  PutApiV1SerievideoVideoidLangsId404,
  PutApiV1SerievideoVideoidLangsId500,
  PutApiV1SerievideoVideoidLangsIdMutationRequest,
  PutApiV1SerievideoVideoidLangsIdMutationResponse,
  PutApiV1SerievideoVideoidLangsIdPathParams,
  PutApiV1SerievideoVideoidLangsIdQueryParams,
} from "../../types/serieVideoIdiomasController/PutApiV1SerievideoVideoidLangsId.ts";
import { serieVideoLangViewModelSchema } from "../serieVideoLangViewModelSchema.ts";
import { updateSerieVideoLangRequestViewModelSchema } from "../updateSerieVideoLangRequestViewModelSchema.ts";

export const putApiV1SerievideoVideoidLangsIdPathParamsSchema = z.object({
  videoId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1SerievideoVideoidLangsIdPathParams>;

export const putApiV1SerievideoVideoidLangsIdQueryParamsSchema = z
  .object({
    serieId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<PutApiV1SerievideoVideoidLangsIdQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1SerievideoVideoidLangsId202Schema = z.lazy(
  () => serieVideoLangViewModelSchema,
) as unknown as ToZod<PutApiV1SerievideoVideoidLangsId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1SerievideoVideoidLangsId400Schema =
  z.any() as unknown as ToZod<PutApiV1SerievideoVideoidLangsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1SerievideoVideoidLangsId401Schema =
  z.any() as unknown as ToZod<PutApiV1SerievideoVideoidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1SerievideoVideoidLangsId404Schema =
  z.any() as unknown as ToZod<PutApiV1SerievideoVideoidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1SerievideoVideoidLangsId500Schema =
  z.any() as unknown as ToZod<PutApiV1SerievideoVideoidLangsId500>;

export const putApiV1SerievideoVideoidLangsIdMutationRequestSchema = z.lazy(
  () => updateSerieVideoLangRequestViewModelSchema,
) as unknown as ToZod<PutApiV1SerievideoVideoidLangsIdMutationRequest>;

export const putApiV1SerievideoVideoidLangsIdMutationResponseSchema = z.lazy(
  () => putApiV1SerievideoVideoidLangsId202Schema,
) as unknown as ToZod<PutApiV1SerievideoVideoidLangsIdMutationResponse>;
